import axios from "axios";
const BASE_URL = process.env.REACT_APP_DEV_URL;

export const addWallet = async (token, data) => {
  const url = `${BASE_URL}/wallet/wallet/`;

  // console.log(token, data);
  

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  try {
    const response = await axios.post(url, data, config);
    return response;
  } catch (error) {
    if (
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500
    ) {
      console.log("Validation or Client Error:", error.response);
      return error.response;
    } else {
      console.error("Server or Network Error:", error);
      throw error;
    }
  }
};

export const getAllWallets = async (token, params = {}) => {
  const url = `${BASE_URL}/wallet/wallet/`;

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
    params,
  };

  try {
    const response = await axios.get(url, config);
    return response;
  } catch (error) {
    if (
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500
    ) {
      console.log("Client Error:", error.response);
      return error.response;
    } else {
      console.error("Server or Network Error:", error);
      throw error;
    }
  }
};

export const getWallet = async (token, retailerId) => {
  const url = `${BASE_URL}/wallet/wallet_history/${retailerId}/`;
  // const url = `${BASE_URL}/order/admin_retailer_wallet_history/${retailerId}/`;

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  try {
    const response = await axios.get(url, config);
    return response;
  } catch (error) {
    if (
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500
    ) {
      console.log("Client Error:", error.response);
      return error.response;
    } else {
      console.error("Server or Network Error:", error);
      throw error;
    }
  }
};

export const getWalletHistory = async (token, retailerId) => {
  // const url = `${BASE_URL}/wallet/wallet_history/${retailerId}/`;
  const url = `${BASE_URL}/order/admin_retailer_wallet_history/${retailerId}/`;

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  try {
    const response = await axios.get(url, config);
    return response;
  } catch (error) {
    if (
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500
    ) {
      console.log("Client Error:", error.response);
      return error.response;
    } else {
      console.error("Server or Network Error:", error);
      throw error;
    }
  }
};

export const updateWallet = async (token, data) => {
  const url = `${BASE_URL}/wallet/wallet/`;

  const config = {
    headers: {
      Authorization: `Token ${token}`,
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await axios.patch(url, data, config);
    return response;
  } catch (error) {
    if (
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500
    ) {
      console.log("Validation or Client Error:", error.response);
      return error.response;
    } else {
      console.error("Server or Network Error:", error);
      throw error;
    }
  }
};
